<template>
    <div>
        <div class="search-select-container" v-if="!value">
            <input class="form-control" type="text" :name="`search_${id}`" :id="`search_${id}`" autocomplete="off"
                :placeholder="placeholder" v-model="search" />

            <uiv-btn v-if="search" class="clear" type="danger" size="xs" @click="onReset">Clear</uiv-btn>

            <div class="search-select-list" :class="{ invalid: error }">
                <div class="item not-found" v-if="!filteredList().length">
                    0 matches for '{{ search }}'
                </div>

                <button class="item" type="button" v-for="(item, index) in filteredList()" :key="index"
                    @click="onSelect(item)">
                    {{ item[labelKey] }}
                </button>
            </div>
        </div>

        <div class="search-selected-item" v-if="value">
            <p>
                <slot></slot>
            </p>

            <div class="text-right">
                <uiv-btn type="ghost" size="xs" @click="onReset">Change</uiv-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchSelectList',
    props: {
        id: String,
        selectList: {
            type: Array,
            default: []
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        error: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            value: null,
            search: ''
        };
    },
    methods: {
        filteredList() {
            if (!this.selectList.length || !this.search) return this.selectList;

            return this.selectList.filter(item => this.search
                .toLowerCase()
                .split(' ')
                .every(v => {
                    const trim = item[this.labelKey].replace(/\s/g, '');

                    return trim.toLowerCase().includes(v);
                })
            );
        },
        onReset() {
            this.search = '';
            this.value = null;
            this.$emit('input', null);
            this.$emit('onReset');
        },
        onSelect(selected) {
            this.$emit('input', selected);
            this.$emit('onChoose', selected);

            this.value = selected;
        }
    }
};
</script>

<style lang="scss">
.search-select-container {
    position: relative;

    >.clear {
        position: absolute;
        top: 8px;
        right: 8px;
    }

    >.form-control {
        padding-right: 65px;
    }
}

.search-select-list {
    margin-top: 5px;
    border: 1px solid #dadada;
    border-radius: 4px;
    padding: 10px 5px;
    max-height: 255px;
    overflow-y: auto;

    >.item {
        display: block;
        width: 100%;
        text-align: left;
        margin-bottom: 8px;
        background-image: none;
        border: none;
        background-color: #f9f9f9;
        padding: 8px 15px;
        border-radius: 4px;
        font-size: 12px;
        border: 2px solid transparent;

        &:last-child {
            margin: 0;
        }

        &:hover,
        &:focus {
            border-color: $brand-colour-primary;
        }
    }

    >.item.not-found {

        &:hover,
        &:focus {
            border-color: transparent;
        }
    }
}

.search-selected-item {
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #dadada;

    >p {
        color: #909090;
        margin-top: 0;
        margin-bottom: 12px;
    }
}
</style>
